import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

const useFocusOnError = ({ fieldRef, name }: any) => {
    const formik = useFormikContext();
    const prevSubmitCountRef = React.useRef(0);
    const firstErrorKey = Object.keys(formik.errors)[0];

    useEffect(() => {
        if (
            fieldRef?.current &&
            name &&
            prevSubmitCountRef?.current !== formik?.submitCount &&
            !formik?.isValid &&
            firstErrorKey === name
        ) {
            fieldRef?.current?.scrollIntoView &&
                fieldRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest',
                });

            setTimeout(() => {
                fieldRef?.current?.focus();
            }, 1000);

            prevSubmitCountRef.current = formik.submitCount;
        }
    }, [formik.submitCount, formik.isValid, firstErrorKey]);
};

export default useFocusOnError;
